import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'

import { settlementsQueryKey } from './useSettlements'
import type { SuggestedPeriod } from '../types'

/**
 * Periods derived from the flat's tenancies: tenancy start to 31 December,
 * then whole years. Keeps costs off the days the flat had no tenant.
 */
export function useSuggestedPeriods({
  flat,
  enabled = true
}: {
  flat?: string
  enabled?: boolean
}) {
  async function getPeriods() {
    const response = await apiClient.get<SuggestedPeriod[]>(
      SNA_PREFIX + 'settlements/suggest-periods',
      { params: { flat } }
    )

    return response.data
  }

  return useQuery({
    queryFn: getPeriods,
    enabled: enabled && !!flat,
    queryKey: [...settlementsQueryKey, 'suggest-periods', flat]
  })
}
